import {CtImageType} from './ct-image-type';
import {CtImageSource} from './ct-image-source';

import {construct, createArrayInstance, createInstance, ModelProperties} from '../utils';

export class CtImage {
    id!: number;

    width!: number;

    height!: number;

    filename!: string;

    originalImage!: string;

    optimizedImage!: string;

    enabled!: boolean;

    mimetype!: string;

    typeId!: number;

    type?: CtImageType;

    sources?: CtImageSource[];

    constructor(image?: ModelProperties<CtImage>) {
        if (image) {
            construct(this, image);
            this.type = createInstance(CtImageType, image.type);
            this.sources = createArrayInstance(CtImageSource, image.sources);
        }
    }
}